module.exports = __webpack_public_path__ + "img/stamp-hotel.98ec0366.png";